// extracted by mini-css-extract-plugin
module.exports = {"container":"LangSwitcher_container__G4ThD","item":"LangSwitcher_item__N7WHH"};